/* eslint-disable jsx-a11y/href-no-hash */
import React from 'react';
import { POST_UTILS } from '../constants';

// wraps post contents and applies overlay
export const PostWrapper = (
    {
        className,
        href,
        target,
        overlaySymbol,
        overlayText,
        children,
        id,
        title,
        ariaText,
        externalWindowLinkAriaText
    }) => {
    let ariaLabelText = ariaText;

    if (target === '_blank' && ariaLabelText) {
        ariaLabelText += ` (${externalWindowLinkAriaText})`;
    }

    return (
        <div className={`${className} hs-post hs-post-wrapper col-xs-12 col-sm-6 col-md-4 col-lg-4`}>
            <a
                href={href}
                target={target}
                data-click-type="post-click"
                data-post-id={id}
                rel={target === '_blank' ? 'noopener' : null}
                aria-label={ariaLabelText || 'link'}
                title={title || 'link'}
            >
                <div className="wrapper">
                    <div className="overlay">
                        <p><span className={`fa fa-${overlaySymbol}`} /> {overlayText}</p>
                    </div>
                    {children}
                </div>
            </a>
        </div>
    );
};

PostWrapper.defaultProps = {
    overlaySymbol: POST_UTILS.DEFAULT_PROPS.OVERLAY_SYMBOL,
    overlayText: POST_UTILS.DEFAULT_PROPS.OVERLAY_TEXT,
    href: POST_UTILS.DEFAULT_PROPS.HREF,
    className: POST_UTILS.DEFAULT_PROPS.CLASS_NAME,
    target: POST_UTILS.DEFAULT_PROPS.TARGET
};

// modal window associated with a post
export const PostModal = ({ id, children }) => {
    return (
        <section
            className="hs-post hs-post-modal modal--show"
            id={id}
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
        >
            <div className="modal-inner">
                <div className="modal-content">
                    {children}
                </div>
            </div>
            <a
                href="#!"
                className="modal-close"
                title={POST_UTILS.POST_MODAL_ANCHOR_TITLE}
                data-close="Close"
                data-dismiss="modal"
            >?</a>
        </section>
    );
};



// WEBPACK FOOTER //
// ./components/post_list/post_utils.jsx